import Wrapper from './_views/Wrapper.vue';

const parentRouteConfig = {
  name: 'Applications',
  to: {
    name: 'applications',
    query: {
      activeOnly: true,
    },
  },
};

export default {
  path: '/applications',
  component: Wrapper,
  children: [
    {
      path: '',
      name: 'applications',
      component: () => import(/* webpackChunkName: "applications" */ './_views/UmsApplications'),
      meta: {
        title: 'Applications',
        navigation: {
          position: 2,
          name: 'Applications',
          icon: 'dashboard',
          to: {
            name: 'applications',
            query: {
              activeOnly: true,
            },
          },
        },
      },
    },
    {
      path: 'history/:app',
      name: 'applicationHistory',
      component: () => import(/* webpackChunkName: "applicationsHistory" */ './_views/UmsApplicationHistory'),
      meta: {
        title: 'Application history',
        parent: parentRouteConfig,
        customDisplayedParamKey: 'app',
      },
    },
  ],
};
